<template>
    <div class="bottom-list-wrap" >
        <ul class="custom-scroller">
        
        <p v-for="(rule, id) in the_rule_data.activity_rules">
            <span class="num">{{id+1}}.&nbsp</span>
            <span class="text">{{rule.content}}</span>
            

        </p>

        
        </ul>
        
    </div>
</template>
<script>
export default {
    data(){
        return {
            show: true,
            the_rule_data: {
                "title": "活動辦法",
                "activity_rules": [
                    {
                        "rule_id": 1,
                        "content": "本活動收集卡、印花貼紙僅適用於指定日期之營業時間內兌換、使用，不可與其他活動合併使用，逾期作廢，亦不得兌換現金。收集卡、印花貼紙一張限兌換乙次，兌換後由門市人員回收。"
                    },
                    {
                        "rule_id": 2,
                        "content": "印花貼紙計算限單次、單筆交易，且預購、提貨券、門市現貨販售、大宗交易等分屬不同交易類型，各管道視為個別交易、不同發票之金額無法合併計算。印花貼紙請於收銀台交易完成後當場清點，遺失或離櫃後恕不補發，請妥善保存。"
                    },
                    {
                        "rule_id": 3,
                        "content": "印花貼紙若有破損、無法辨識、影印者無效，偽造者依法究辦。"
                    },
                    {
                        "rule_id": 4,
                        "content": "菸品、一歲以下嬰幼兒奶粉、福利卡/電子票證儲值、代收/售、購買禮券、折價券/購物金、印花或福利點換購Bodum商品、賣場/官網/DM/APP標示或公告之指定排除商品等，皆不列入本活動消費金額之計算。"
                    },
                    {
                        "rule_id": 5,
                        "content": "原購買商品退貨時，如扣除該商品價額未達印花贈送門檻或條件，需同時退回該筆交易所溢領之印花貼紙，否則將視為商品退貨不完全，恕無法提供退貨服務。"
                    },
                    {
                        "rule_id": 6,
                        "content": "換購商品配件依型號不同以實物為準，圖片僅供參考，庫存依各門市現場為主，數量有限換完為止。若遇供貨不及或換購最後一週（2019/05/10~05/16），本公司將統一開放提貨券預購結帳。提貨券請妥善保存，並於券上載明之兌領期間內，持提貨券正本回發放門市領取指定商品，提貨券遺失或逾期視為自動放棄門市不負保管責任。"
                    },
                    {
                        "rule_id": 7,
                        "content": "本活動換購之商品均由丹麥Bodum原廠提供，儲物罐600cc及哥本哈根保溫瓶1.1L為Bodum葡萄牙廠製造、其餘商品為Bodum中國廠製造，商品皆已通過SGS檢驗。"
                    },
                    {
                        "rule_id": 8,
                        "content": "儲物罐600cc為紅色、白色隨機出貨，不鏽鋼真空隨行杯為紅色、黑色隨機出貨，恕無法挑選或指定顏色。"
                    },
                    {
                        "rule_id": 9,
                        "content": "本活動換購商品一經於全聯福利中心門市進行換購，印花貼紙將不予歸還，亦不接受退換貨，若為出廠瑕疵，亦僅能更換同款商品。"
                    },
                    {
                        "rule_id": 10,
                        "content": "電動虹吸式咖啡壺全國限量18,000台（含現貨、展示品及備品）、福利卡獨享「800福利點加229元換購儲物罐600cc」及「800福利點加549元換購不鏽鋼真空隨行杯0.35L」各限量20,000組、「1,000福利點加1,600元換購美式濾滴咖啡機」限量10,000組，換完活動即停止，恕不另行公告。"
                    },
                    {
                        "rule_id": 11,
                        "content": "Bodum電器類商品正常使用下，自購買取貨日起6個月內由原廠指定之活動代理商提供有條件之維修服務（不包含耗材），此服務之商品維修、零件更換以及運送過程中所產生之相關費用等需自行負擔，服務詳細規範與說明依品牌指定之活動代理商說明為主，本服務僅限臺灣，其他國家或地區無法使用。非電器類商品屬消耗品，無提供維修服務。"
                    },
                    {
                        "rule_id": 12,
                        "content": "若對於換購之Bodum商品有任何問題，請致電活動客服（02）2657-0607洽詢（週一至週五09:30-17:00，國定例假日除外）。"
                    },{
                        "rule_id": 13,
                        "content": "全聯福利中心保有最終解釋、調整與修改本活動辦法之權利，活動詳情及其他未盡事宜請至全聯官網或活動網站查詢。"
                    }
                ]
            }
        }
    },
    props: ['rule_datas'],
    methods: {
        ct_scroll(){
            $(".custom-scroller").mCustomScrollbar({
                theme: "rounded-dots",
                mouseWheelPixels: 80,
                scrollInertia: 0
            });

        }
    },
    created(){
        setTimeout(()=>{
            $(".custom-scroller").css("opacity", "1"); 
            this.ct_scroll();
        },150);
    }
}



</script>
<style lang="sass">
.custom-scroller
    transition: .3s
</style>


// WEBPACK FOOTER //
// src/ActRules/list.vue